export default __webpack_public_path__ + "static/media/default-avatar.a7e77e3a.png";